import { META_FIELD_BEHAVIOR, MetaData, MetaPayload } from "../../../../domains/models/document";
import { RcFile } from "antd/lib/upload";
import dayjs from "dayjs";
import Locale from "../../../../core/locale/locale";
import { FormFields } from "../type/upload-document-modal.types";

export function getUIMetaFields(data: MetaData[]): MetaData[] {
    return data.filter((item) =>
        META_FIELD_BEHAVIOR[item.metaField as keyof typeof META_FIELD_BEHAVIOR] !== 'SYSTEM'
    );
}

export function getSystemMetaFields(data: MetaData[]): MetaData[] {
    return data.filter((item) =>
        META_FIELD_BEHAVIOR[item.metaField as keyof typeof META_FIELD_BEHAVIOR] === 'SYSTEM'
    );
}

export function getSystemFieldsValue(
    systemMetaData: MetaData[],
    file: RcFile,
    documentNumber?: string
): MetaPayload[] {

    return systemMetaData.reduce<MetaPayload[]>((acc, meta) => {

        switch (meta.metaField) {
            case 'capturedDate':
                acc.push({
                    metaValue: dayjs().format(Locale.dateFormat),
                    metaField: meta.metaField,
                    metaType: meta.metaFieldType,
                    label: meta.label
                });
                break;

            case 'location':
                acc.push({
                    metaValue: 'AUTO_LOCATION',
                    metaField: meta.metaField,
                    metaType: meta.metaFieldType,
                    label: meta.label
                });
                break;

            case 'format': {
                const fileType = file?.type;

                if (fileType) {
                    const format = fileType.split('/').pop() ?? '';

                    acc.push({
                        metaValue: format,
                        metaField: meta.metaField,
                        metaType: meta.metaFieldType,
                        label: meta.label
                    });
                }
                break;
            }

            case 'identityNumber':
                acc.push({
                    metaValue: documentNumber ?? '',
                    metaField: meta.metaField,
                    metaType: meta.metaFieldType,
                    label: meta.label
                });
                break;
        }

        return acc;
    }, []);
}

export function getMetaValuesFromUI(
    uiMetaData: MetaData[],
    formValues: Record<string, any>
): MetaPayload[] {
    return Object.entries(formValues).map(([key, value]) => {
        const uiMeta = uiMetaData.find((i) => i.metaField === key);
        if (!uiMeta) return null;
        let formattedValue = value;

        if (value === undefined || value === null) return null;

        if (value instanceof Date) {
            formattedValue = dayjs(value).format(Locale.dateFormat);
        } else if (dayjs.isDayjs(value)) {
            formattedValue = value.format(Locale.dateFormat);
        } else if (key === 'tag') {
            formattedValue = value.join(',');
        }
        return {
            metaValue: formattedValue,
            metaField: uiMeta.metaField,
            metaType: uiMeta.metaFieldType,
            label: uiMeta.label
        };
    }).filter((item): item is MetaPayload => item !== null);
}

export function mapMetaDataToFormField(data: MetaData[]): FormFields[] {

    return data.map((item) => ({
        label: item.label,
        name: item.metaField,
        required: item.required,
        type: item.metaFieldType,
    }));

}

export const bytesToMegaBytes = (bytes: number, decimals = 2) => {
    if (bytes === 0) return 0;
    const mbValue = bytes / (1024 * 1024);

    return Number(mbValue.toFixed(decimals));
};

